import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../../services/api';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading | success | error

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      return;
    }
    (async () => {
      try {
        await api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`);
        setStatus('success');
      } catch {
        setStatus('error');
      }
    })();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="bg-slate-800 rounded-xl p-8 max-w-md w-full text-center">
        {status === 'loading' && (
          <>
            <div className="text-4xl mb-4">&#x23F3;</div>
            <p className="text-slate-300">Verifying your email...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="text-4xl mb-4">&#x2705;</div>
            <h2 className="text-xl font-semibold text-white mb-2">Email verified!</h2>
            <p className="text-slate-400 mb-6">
              You can now connect your broker and start tracking trades.
            </p>
            <Link
              to="/"
              className="inline-block bg-emerald-600 hover:bg-emerald-500 text-white px-6 py-3 rounded-lg"
            >
              Go to Dashboard
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="text-4xl mb-4">&#x274C;</div>
            <h2 className="text-xl font-semibold text-white mb-2">Link invalid or expired</h2>
            <p className="text-slate-400 mb-6">
              This verification link has expired or already been used.
            </p>
            <Link
              to="/"
              className="inline-block bg-slate-700 hover:bg-slate-600 text-white px-6 py-3 rounded-lg"
            >
              Back to app
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
